import style from './Card.module.css';

const Card = (props) => {
  const theme = ['primary', 'success', 'info', 'warning', 'danger', 'dark'].includes(props.theme) ? props.theme : 'default';

  const hasPaddings = props.paddings !== false;

  return (
    <div className={`${style.card} ${props.className} ${style[theme]}`}>
      {
        props.header && (<div className={style['card-header']}><h3>{props.header}</h3></div>)
      }
      <div className={`${style['card-content']} ${hasPaddings ? style['card-spacing'] : ''}`}>
        {props.children}
      </div>
      {
        props.footer && (<div className={style['card-footer']}>{props.footer}</div>)
      }
    </div>
  );
};

export default Card;